import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";
import { objToParams } from "../../utils/func";

const initialState = {
  memberUpgradeApps: [],
  membershipUpgrade: [],
  memberUpgradeDetails: "",
  loading: false,
  error: null,
  memberUpgradeAppsParams: {
    status: "Pending",
    page: 1,
    pageSize: 5,
  },
};

export const fetchMembershipUpgradeIndividual = createAsyncThunk(
  "membershipUpgrade/fetchMembershipUpgradeIndividual",
  async () => {
    return httpRequest(
      `${BASE_URL}/v2/MembershipUpgrade/individual?PageSize=1000`
    );
  }
);
export const fetchMembershipUpgradeCorporate = createAsyncThunk(
  "membershipUpgrade/fetchMembershipUpgradeCorporate",
  async () => {
    return httpRequest(
      `${BASE_URL}/v2/MembershipUpgrade/corporate?PageSize=1000`
    );
  }
);

export const fetchMemberUpgradeApps = createAsyncThunk(
  "membershipUpgrade/fetchMemberUpgradeApps",
  async ({ route, status }, { getState }) => {
    const url = `${BASE_URL}/v2/MembershipUpgrade${route}${objToParams(
      getState()?.membershipUpgrade?.memberUpgradeAppsParams
    )}`;
    return httpRequest(url);
  }
);

export const memberUpgradeApprove = createAsyncThunk(
  "membershipUpgrade/membershipUpgradeApprove",
  async ({ arg, id, currentCategory }, { rejectWithValue }) => {
    try {
      const corporateCategories = [
        "Standard",
        "Bronze",
        "Silver",
        "Gold",
        "GoldPlus",
        "Diamond",
        "Platinum",
        "PlatinumPlus",
      ];
      const isCorporate = corporateCategories.includes(currentCategory);

      const endpointType = isCorporate ? "corporate" : "individual";
      const response = await httpRequest(
        `${BASE_URL}/v2/MembershipUpgrade/${id}/${endpointType}/approve`,
        "post",
        arg
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const membershipUpgradeSlice = createSlice({
  name: "membershipUpgrade",
  initialState,
  reducers: {
    setMemberUpgradeDetails: (state, { payload }) => {
      state.memberUpgradeDetails = payload;
    },

    setUpdateMemberUpgradeAppsStatus: (state, { payload }) => {
      state.memberUpgradeAppsParams.status = payload;
      state.memberUpgradeApps = [];
    },
    setUpdateMemberUpgradeAppsPagination: (state, { payload }) => {
      state.memberUpgradeAppsParams.page = payload;
      state.memberUpgradeApps = [];
    },
    setUpdateMemberUpgradeAppsPageSize: (state, { payload }) => {
      state.memberUpgradeAppsParams.pageSize = payload;
      state.memberUpgradeApps = [];
    },
  },
  extraReducers: (builder) => {
    // get all membership upgrade Individual
    builder.addCase(fetchMembershipUpgradeIndividual.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      fetchMembershipUpgradeIndividual.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.membershipUpgrade = payload;
        state.error = null;
      }
    );

    builder.addCase(
      fetchMembershipUpgradeIndividual.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    ); // get all membership upgrade Corporate
    builder.addCase(fetchMembershipUpgradeCorporate.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      fetchMembershipUpgradeCorporate.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.membershipUpgrade = payload;
        state.error = null;
      }
    );

    builder.addCase(
      fetchMembershipUpgradeCorporate.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    );

    // get all membership upgrade applications
    builder.addCase(fetchMemberUpgradeApps.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      fetchMemberUpgradeApps.fulfilled,
      (state, { payload, meta }) => {
        state.loading = false;
        if (meta.arg.route.includes("individual-application")) {
          state.individualApps = payload;
        } else {
          state.corporateApps = payload;
        }
        state.error = null;
      }
    );

    builder.addCase(fetchMemberUpgradeApps.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    // membership upgrade approve

    builder.addCase(memberUpgradeApprove.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(memberUpgradeApprove.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.error = null;
    });

    builder.addCase(memberUpgradeApprove.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });
  },
});

export const {
  setMemberUpgradeDetails,
  setUpdateMemberUpgradeAppsStatus,
  setUpdateMemberUpgradeAppsPagination,
  setUpdateMemberUpgradeAppsPageSize,
} = membershipUpgradeSlice.actions;
export default membershipUpgradeSlice.reducer;
